<template>
    <div class="p-grid">
        <div class="hse-page-1">
            <div class="f-grid-ind">
              <div class="f-grid-col-ind" v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
                <div class="ind-text">Công ty</div>
                <div class="idn-sel">
                  <DropdownScrollable placeholder="Chọn công ty" :limit="company_obj.limit" :loading="company_obj.loading" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="company_obj.items" :total="company_obj.total" @keyup="emitEvent" @offset="changeOffset" :showClear="true"/>
                </div>
              </div>
            </div>
            <div class="hse-section-1">
                <h2 class="hse-section-title-1">Tổng quan nhà thầu</h2>
                <div class="hse-grid-1">
                    <!-- Item 1 -->
                    <div class="hse-box-1">
                        <div class="hse-box-content">
                            <div class="hse-box-left-1">
                                <div>
                                    <span class="hse-card-title-1">{{ item_1.name }}</span>
                                </div>
                                <div class="hse-box-desc-1">
                                    <div v-if="item_1.loading" class="spinner-loading"></div>
                                    <span v-else class="hse-card-desc-1">{{ item_1.value }}</span>
                                </div>
                            </div>
                            <div class="hse-box-right-1">
                                <div class="hse-box-icon-wrapper-1">
                                    <img :src="item_1.image" class="hse-box-icon-1 image1-1" />
                                </div>
                            </div>
                        </div>
                        <div class="hse-card-text">
                            {{ item_1.text }}
                        </div>
                        
                    </div>

                    <!-- Item 2 -->
                    <div class="hse-box-1">
                        <div class="hse-box-content">
                            <div class="hse-box-left-1">
                                <div>
                                    <span class="hse-card-title-1">{{ item_2.name }}</span>
                                </div>
                                <div>
                                    <div v-if="item_2.loading" class="spinner-loading"></div>
                                    <span v-else class="hse-card-desc-1">{{ item_2.value }}</span>
                                </div>
                            </div>
                            <div class="hse-box-right-1">
                                <img :src="item_2.image" class="hse-box-icon-1 image1-1" />
                            </div>
                        </div>
                        <div class="hse-card-text">
                            {{ item_2.text }}
                        </div>
                    </div>

                    <!-- Item 3 -->
                    <div class="hse-box-1">
                        <div class="hse-box-content">
                            <div class="hse-box-left-1">
                                <div>
                                    <span class="hse-card-title-1">{{ item_3.name }}</span>
                                </div>
                                <div>
                                    <div v-if="item_3.loading" class="spinner-loading"></div>
                                    <span v-else class="hse-card-desc-1">{{ item_3.value }}</span>
                                </div>
                            </div>
                            <div class="hse-box-right-1">
                                <img :src="item_3.image" class="hse-box-icon-1 image1-1" />
                            </div>
                        </div>
                        <div class="hse-card-text">
                            {{ item_3.text }}
                        </div>
                    </div>

                    <!-- Item 4 -->
                    <div class="hse-box-1">
                        <div class="hse-box-content">
                            <div class="hse-box-left-1">
                                <div>
                                    <span class="hse-card-title-1">{{ item_4.name }}</span>
                                </div>
                                <div>
                                    <div v-if="item_4.loading" class="spinner-loading"></div>
                                    <span v-else class="hse-card-desc-1">{{ item_4.value }}</span>
                                </div>
                            </div>
                            <div class="hse-box-right-1">
                                <img :src="item_4.image" class="hse-box-icon-1 image1-1" />
                            </div>
                        </div>
                        <div class="hse-card-text">
                            {{ item_4.text }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div class="p-col-12">
            <div class="card card-w-title">
                <div class="manager-title" >CẢNH BÁO SẮP HẾT HẠN</div>

                <BaseDatatable
                    :key="componentKey"
                    :tableData="listData"
                    :model="dataModel"
                    :options="options"
                    :filterDefault="filters"
                    :getFilterOptions="getFilterOptions"
                    :actions="getRowActions()"
                    v-on:action-click="onActionClicked"
                    @onEventOptions="onEventOptions"
                    @onDataChange = 'DataOnChange'
                    :company="company"
                ></BaseDatatable>
            </div>
        </div>

        <div class="p-col-12">
            <div class="card card-w-title">
                <div class="manager-title" >CẢNH BÁO SẮP HẾT HẠN VẬT TƯ/THIẾT BỊ</div>

                <BaseDatatable
                    :key="componentKeySuppliesEquipment"
                    :tableData="listDataSuppliesEquipment"
                    :model="dataModelSuppliesEquipment"
                    :options="options"
                    :filterDefault="filters"
                    :getFilterOptions="getFilterOptionsSuppliesEquipment"
                    :actions="getRowActions()"
                    v-on:action-click="onActionClicked"
                    @onEventOptions="onEventOptions"
                    @onDataChange = 'DataOnChange'
                    :company="company"
                ></BaseDatatable>
            </div>
        </div>
    </div>
</template>

<script>
import GetConstants from './../../../core/Constants';
var Constants = GetConstants.getConstans();
import ApiRepository from "@/core/ApiRepository";
import DataServices from '@/core/DataServices';
import BaseDatatable from './list';
import DropdownScrollable from '@/components/DropdownScrollable';
export default {
    components: {
        BaseDatatable,
        DropdownScrollable
    },
    data() {
        return {
            item_1: {
                image: "/../../../assets/layout/images/item_1.png",
                name: "Số nhà thầu đang hoạt động",
                value: 0,
                text: "Đang cung cấp dịch vụ",
                loading: true,
            },
            item_2: {
                image: "/../../../assets/layout/images/item_2.png",
                name: "Số nhân viên của nhà thầu",
                value: 0,
                text: "Số nhân viên đang hoạt động",
                loading: true,
            },
            item_3: {
                image: "/../../../assets/layout/images/item_3.png",
                name: "Tổng số giờ làm việc của tất cả NT",
                value: 0,
                text: "",
                loading: true,
            },
            item_4: {
                image: "/../../../assets/layout/images/item_4.png",
                name: "Số gói công việc",
                value: 0,
                text: "Tổng gói công việc của tổng các nhà thầu",
                loading: true,
            },
            filters : {},
            filterOptions: {},
            options: [],
            listData: [],
            modelName: '',
            dataModel: null,
            title: '',
            componentKey: 0,
            listDataSuppliesEquipment: [],
            modelNameSuppliesEquipment: 'supplies_equipment_warning',
            dataModelSuppliesEquipment: null,
            componentKeySuppliesEquipment: 0,
            page_transaction:null,
            editId: null,
            displayDialog: false,
            editDialogKey: 0,
            dialogMode: 'edit',
            deleteId: null,
            deleteName: null,
            showDeleteDialog: false,
            dataDelete :{},
            role: {
                view: false,
                add: false,
                edit: false,
                delete: false,
            },
            company: {},
            company_obj: {
                offset: 0,
                filters: {},
                limit: 20,
                items: [],
                total: 0,
                loading: false
            },
            company_id: null,
        };
    },
    async created() {
        // console.log("overview created");
        // console.log(" this.$constants.TYPE_USER.SUPPER_ADMIN===222:", this.$constants.TYPE_USER.SUPPER_ADMIN);
        this.initParams();
        await this.LoadOverviewData();
        console.log("this.$store.getters",this.$store.getters)
        this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
        this.modelName = this.$route.meta.model;
        this.$store.commit('setLoading', true);
        if(this.$route.params.reload) {
            window.location.reload();
        }
        var type_login = this.$store.getters.type ? this.$store.getters.type : null;
        if(type_login == this.$constants.TYPE_USER.SUPPER_ADMIN){
          await this.getListCompany();
        }
    },
    watch: {
        '$route': 'initParams',
        async 'company'() {
          await this.LoadOverviewData();
          // this.componentKey ++;
        },
    },
    methods: {
      async LoadOverviewData() {
        var type_login = this.$store.getters.type ? this.$store.getters.type : null;
          
          var token = this.$store.getters.token ? this.$store.getters.token : null
          if(token){
              const headers = {
                  "Authorization": "Bearer "+token,
              };
              var object = {};
              if(type_login == this.$constants.TYPE_USER.SUPPER_ADMIN){
                if (this.company && this.company.id) {
                  object.company_id = this.company.id;
                } else {
                  this.item_1.loading = true;
                  this.item_2.loading = true;
                  this.item_3.loading = true;
                  this.item_4.loading = true;
                  return;
                }
              }
              var overview_data = await ApiRepository.post(Constants.API.OVERVIEW, object, {headers}).then(function (response) {
                  var data = response?.data?.data ?? [];
                  // console.log('data menu', data);
                  return data
              }).catch(function (error) {
                  console.log('error', error);
                  return []
              });
              // console.log('overview_data==', overview_data);
              if(overview_data){
                  this.item_1.value = this.formatNumber(overview_data.total_contractor ?? 0,0);
                  this.item_1.loading = false;
                  this.item_2.value = this.formatNumber(overview_data.total_users_contractor ?? 0,0);
                  this.item_2.loading = false;
                  this.item_3.value = this.formatNumber(overview_data.total_hours ?? 0,0);
                  this.item_3.loading = false;
                  this.item_4.value = this.formatNumber(overview_data.total_sra ?? 0,0);
                  this.item_4.loading = false;
              }
          }
      },
      formatNumber(value,decimals=2){
          const digitsRE = /(\d{3})(?=\d)/g
          value = parseFloat(value)
          if (!isFinite(value) || (!value && value !== 0)) return ''
          decimals = decimals != null ? decimals : 2
          var stringified = Math.abs(value).toFixed(decimals)
          var _int = decimals
              ? stringified.slice(0, -1 - decimals)
              : stringified
          var i = _int.length % 3
          var head = i > 0
              ? (_int.slice(0, i) + (_int.length > 3 ? '.' : ''))
              : ''
          var _float = decimals
              ? stringified.slice(-1 - decimals)
              : ''
          var sign = value < 0 ? '-' : '';
          var text = sign + head +
              _int.slice(i).replace(digitsRE, '$1.') +
              _float
          return text
      },
      emitEvent(keyword) {
        this.$delete(this.company_obj.filters, 'name');
        if (keyword) {
          this.company_obj.filters.name = keyword;
        }
        this.getListCompany();
      },
    changeOffset(value) {
      this.company_obj.offset = value;
      // this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.company_obj.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.company_obj.filters, limit: this.company_obj.limit, offset: this.company_obj.offset}, {headers}).then((res) => {
          if (this.company_obj.offset > 0 ) {
            this.company_obj.items.push(...res.data.data.company);
          } else{
            this.company_obj.items = res.data.data.company;
          }
          this.company_obj.total = res.data.data.total;
          this.company_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.company_obj.loading = false;
        })
      }
    },

    async onEventOptions({event, key, data}) {
      console.log("key", key);
      console.log("event", event);
      if (key == "department") {
        console.log(data);
        this.department_obj = data;
        if (event == 'offset' || event == 'scroll') {
          await this.getListDepartment();
        }
      }
    },
    async getListDepartment() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.options["department"] = [];
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.department_obj.loading = true;
        if (!this.department_obj?.filters) {
          this.department_obj.filters = {};
        }
        this.department_obj.filters.company_id = this.company?.id;
        await ApiRepository.post("/_api/department/options", {filters: this.department_obj.filters, limit: this.department_obj.limit, offset: this.department_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
          if (this.department_obj.offset > 0 ) {
            this.department_obj.items.push(...res.data.data.department);
          } else{
            this.department_obj.items = res.data.data.department;
          }
          this.department_obj.total = res.data.data.total;
          this.department_obj.loading = false;
          this.options["department"] = this.department_obj;
        }).catch((err) => {
            console.log(err);
            this.department_obj.loading = false;
        })
      }
    },
    initParams() {
      this.$store.commit('setLoading', true);
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel(this.modelName);
      this.title = this.dataModel.label;
      this.dataModelSuppliesEquipment = DataServices.getModel(this.modelNameSuppliesEquipment);
      // this.callbackOptions();
    },
    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },
    DataOnChange(data,f){
      if(f.type == 'Checkbox'){
      //   let dataUpdate = {}
      //   if(f.key == 'active'){
      //     dataUpdate['active'] = data[f.key]
      //   }
      //   let variables = {
      //     'data_update': dataUpdate,
      //     'where_key': {
      //       'id': {'_eq': data.id}
      //     }
      //   };
      //   this.$apollo.mutate({
      //     mutation: DataServices.updateData(this.modelName),
      //     variables: variables
      //   }).then(() => {})
      }
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      // console.log("field",field)
      var result = []
      if (field.type == 'Selection') {
        if (field.options ) result = field.options;
        else if(field.models && this.options[name]) result = this.options[name];
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      // console.log("result",result)
      return result;
    },
    getFilterOptionsSuppliesEquipment(name) {
      var field = this.dataModelSuppliesEquipment.getField(name)
      var result = []
      if (field.type == 'Selection') {
        if (field.options ) result = field.options;
        else if(field.models && this.options[name]) result = this.options[name];
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      return result;
    },
    getRowActions() {
      var actions = {}
      
      return actions
    },
    async callbackOptions() {
      this.dataModel.getDisplayFields();
      // var attributes = [];
      // for (let index = 0; index < fields.length; index++) {
      //   const element = fields[index];
      //   console.log(element.key);
      //   if (element.models !== undefined && element.models !== null) {
      //     // console.log("SDFGHJK",element)
      //     var optionsData = [];
      //     if( element['name']== "position"){
      //       // console.log("element",element)
            
      //     }
      //     // console.log("optionsData",optionsData)
      //     this.options[element.key] = optionsData;
      //   }
      //   this.componentKey++;
      // }

    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key]})
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path + data.data[action.key],query: { page_transaction: pageTransaction.toString(), company_id: this.company_id }  })
          } else  {
            this.page_transaction = pageTransaction.toString();
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name_en
          this.dataDelete = data.data
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path,query: { company_id: this.company_id }  })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'calculator':
          this.dialogMode = action.name
          this.$router.push({ path: action.path, query: { company_id: data.data[action.key] }  })
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
      }
    },
    async sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async deleteData() {
      this.showDeleteDialog = false
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/users/delete", {user_id: that.deleteId}, {headers}).then(function () {
          that.componentKey += 1;
        }).catch((err) => {
          that.$toast.add({
                severity: 'error',
                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: err,
                life: 3000
            })
        })
      }
    },
    emitEventContractor(keyword) {
      // console.log(keyword);
      this.$delete(this.contractor_obj.filters, 'filter_txt');
      if (keyword) {
        this.contractor_obj.filters.filter_txt = keyword;
      }
      this.getListContractor();
    },
    changeOffsetContractor(value) {
      this.contractor_obj.offset = value;
    },
    async getListContractor() {
      console.log("DAsdasdasdad")
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.contractor_obj.loading = true;
        await ApiRepository.post("/_api/contractor/options", {filters: this.contractor_obj.filters, limit: this.contractor_obj.limit, offset: this.contractor_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            if (this.contractor_obj.offset > 0 ) {
              this.contractor_obj.items.push(...res.data.data.contractor);
            } else{
              this.contractor_obj.items = res.data.data.contractor;
            }
            this.contractor_obj.total = res.data.data.count;
            this.contractor_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.contractor_obj.loading = false;
        })
      }
    },
    async clearContractor(){
      console.log("gọi clear")
      this.contractor_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.contractor = null
    },
    
        
  }
};
</script>

<style scoped>
.hse-page-1 {
    background: #f9fafb;
    padding: 24px;
    box-sizing: border-box;
    width: 100%;
}

/* Box chung */
.hse-box-1 {
    display: flex;
    flex-direction: column;  /* Đảm bảo tất cả các phần tử nằm dọc */
    gap: 8px; /* Khoảng cách giữa các phần tử trong mỗi box */
    padding: 8px;
    
    background-color: #ffffff;
    border: 1px solid #b1b1b1;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.hse-box-icon-1 {
    width: 40px;
    height: 40px;
    object-fit: contain;
    display: block;
}

/* Nội dung bên trong mỗi mục */
.hse-box-content {
    display: flex;
    flex-direction: row;  /* Chữ bên trái, hình bên phải */
    gap: 2px;  /* Khoảng cách giữa các phần tử bên trong box */
}

/* Bên trái: chữ */
.hse-box-left-1 {
    display: flex;
    flex-direction: column;
    flex: 1;  /* Phần chữ chiếm hết không gian còn lại */
    margin-top: 0px;
}

.hse-card-title-1 {
    font-weight: 500;
    margin: 0;
    white-space: normal;  /* Cho phép xuống dòng */
    word-wrap: break-word;  /* Cắt từ nếu quá dài */
    font-size: 13px;
    line-height: 1.0;
    color:#20221bd6;
}

.hse-card-desc-1 {
    font-size:20px;
    font-weight: 500;
}

/* Bên phải: hình ảnh */
.hse-box-right-1 {
    display: flex;
    /* align-items: center; */
    justify-content: center;
    width: 40px; /* Cố định chiều rộng */
    position: relative;
}

/* Mô tả text trong hse-box-1 */
.hse-card-text {
    font-size: 13px;
    color: #4b5563;
    /* margin-top: 8px; */
    word-wrap: break-word;  /* Đảm bảo văn bản không bị cắt */
    font-style: italic;
}

/* Section Title */
.hse-section-title-1 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 16px;
}

/* Grid Layout */
.hse-grid-1 {
    display: grid;
    grid-template-columns: repeat(4, 1fr); /* 4 cột trong 1 hàng */
    gap: 10px;
    margin-top: 20px;
}
.hse-box-desc-1 {
    margin-top: 5px;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner-loading {
  width: 20px;
  height: 20px;
  border: 5px solid #ccc;
  border-top: 5px solid #42b983;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }     /* Khi bắt đầu, vòng tròn không quay */
  100% { transform: rotate(360deg); } /* Sau 1 giây, quay đầy một vòng */
}
.hse-section-2 {
    margin-top: 10px;
}
</style>